import OrderDetailInformation from "../Order/OrderDetailInformation";
import React, { Fragment, useEffect, useState } from "react";
import { Formik, Form } from "formik";
import * as Yup from "yup";
import FormikControl from "../CustomedFields/FormikControl";
import { useSelector, useDispatch } from "react-redux";
import Input_Measurement_Print from "./../CustomedFields/Input_Measurement_Print";
// import { assignOrderItemsWithMeasurementStoreForPrint } from "./../../slice/orderSlice";
import useTranslation from "./../../customHooks/translations";

const ShowSingleMeasurementPrint = (props) => {

  const translation = useTranslation();

  //*** Store */
  const dispatch = useDispatch();

  const handleClickDelete = (indexNo, orderDetailID_GUID_props) => {
    // alert(
    //   "Show component: The link was clicked." +
    //     indexNo +
    //     ", " +
    //     orderDetailID_GUID_props
    // );
    props.removeOrderItem(indexNo, orderDetailID_GUID_props);
  };

  const [printArray1, setPrintArray1] = useState([]);
  const [renderedMatrix, setRenderedMatrix] = useState();

  const [orderDetailToShow, setOrderDetailToShow] = useState({});
  const [twoDimantionArray, setTwoDimantionArray] = useState([
    [],
    [],
    [],
    [],
    [],
    [],
    [],
  ]);
  var rowMax = 0;
  var counterCol = 0;
  var counterRow = 0;
  var isFirstRow = true;
  //const [arrayHTML, setArrayHTML] = useState("abc");
  // var arrayHTML1 = "123";

  // below code not using
  const convertToTwoDimantionalArray = () => {
    debugger;

    props.lstMeasurementDetail.forEach((item, index) => {
      if (
        item.value === "" ||
        item.value === null ||
        item.value === "undifined"
      ) {
        // do nothing...
        //  arrayHTML1 += item.fieldName + item.value;
        //** NOTE: added to show blank value also */
        setTwoDimantionArray(twoDimantionArray[counterCol].push(item));
      } else {
        setTwoDimantionArray(twoDimantionArray[counterCol].push(item));
        rowMax = counterRow;
      }

      // counter = 0, after every 7 column.
      if (index % 6 === 0) {
        counterCol = 0;
        isFirstRow = false;
        counterRow = counterRow + 1;
      } else {
        counterCol = counterCol + 1;
      }
    });
  };

  useEffect(() => {
    props.lstMeasurementDetail
      .filter((item) => !item.isNote)
      .forEach((item, index) => {
        // debugger;

        if (
          item.value === "" ||
          item.value === null ||
          item.value === "undifined"
        ) {
          // do nothing...

          //** below code is showing blank row also */
          const matrixCopy = [...twoDimantionArray]; // create a copy of the matrix
          const newItem = item;
          const rowIndex = counterRow;
          const columnIndex = counterCol;
          // matrixCopy[columnIndex][rowIndex] = newItem; // modify the copy by adding the new item
          matrixCopy[columnIndex].push(newItem);
          setTwoDimantionArray(matrixCopy); // update the state with the modified copy

          //  arrayHTML1 += item.fieldName + item.value;
          //*** NoTe: comment below code, if want to show only filled row */
          rowMax = counterRow + 1;
        } else {
          const matrixCopy = [...twoDimantionArray]; // create a copy of the matrix
          const newItem = item;
          const rowIndex = counterRow;
          const columnIndex = counterCol;
          // matrixCopy[columnIndex][rowIndex] = newItem; // modify the copy by adding the new item
          matrixCopy[columnIndex].push(newItem);
          setTwoDimantionArray(matrixCopy); // update the state with the modified copy

          rowMax = counterRow + 1;
        }

        //***  NOTE: old code to show without blank block */
        // if (
        //   item.value === "" ||
        //   item.value === null ||
        //   item.value === "undifined"
        // ) {
        //   // do nothing...
        //   //  arrayHTML1 += item.fieldName + item.value;
        // } else {
        //   const matrixCopy = [...twoDimantionArray]; // create a copy of the matrix
        //   const newItem = item;
        //   const rowIndex = counterRow;
        //   const columnIndex = counterCol;
        //   // matrixCopy[columnIndex][rowIndex] = newItem; // modify the copy by adding the new item
        //   matrixCopy[columnIndex].push(newItem);
        //   setTwoDimantionArray(matrixCopy); // update the state with the modified copy

        //   rowMax = counterRow + 1;
        // }

        // counter = 0, after every 7 column.
        if (index === 0) {
          counterCol = 1;
          //isFirstRow = false;
          // counterRow = 1;
        } else if (counterCol === 6) {
          counterCol = 0;
          //isFirstRow = false;
          counterRow = counterRow + 1;
        } else {
          counterCol = counterCol + 1;
        }
      });

    // console.log(
    //   "2 dymantional array -- props.lstMeasurementDetail : " +
    //     JSON.stringify(props.lstMeasurementDetail) +
    //     props.lstMeasurementDetail.length
    // );

    let divContent = "";

    const renderedMatrix3 = [];
    for (let i = 0; i < rowMax; i++) {
      for (let j = 0; j < twoDimantionArray.length; j++) {
        if (
          twoDimantionArray[j][i] != null &&
          twoDimantionArray[j][i]?.fieldName !== "undefined" &&
          twoDimantionArray[j][i]?.value !== "undefined" &&
          !twoDimantionArray[j][i]?.isNote
        ) {
          divContent += `<div class="singleMeasureToPrint_ParentDiv borderOnePic">`;
          // if (
          //   twoDimantionArray[j][i]?.fieldName != "-" ||
          //   twoDimantionArray[j][i]?.fieldName != ""
          // ) {
          //   divContent += `<div class="singleMeasureToPrint_ChildLeftDiv">`;
          //   divContent += twoDimantionArray[j][i]?.fieldName;
          //   divContent += `<div class="clearBoth"></div>`;
          //   divContent += `</div>`;
          // }

          // if (
          //   twoDimantionArray[j][i]?.fieldName === "-" ||
          //   twoDimantionArray[j][i]?.fieldName === ""
          // ) {
          //   divContent += ` <div class="singleMeasureToPrint_ChildRightDiv width-full-Important">`;
          // } else {
          //   divContent += ` <div class="singleMeasureToPrint_ChildRightDiv borderLeftOnePic">`;
          // }

          divContent += ` <div class="singleMeasureToPrint_ChildRightDiv width-full-Important">`;
          divContent +=
            twoDimantionArray[j][i]?.value +
            ` &nbsp &nbsp &nbsp ` +
            "<div style='font-size: 10px;text-align: center;'>" +
            twoDimantionArray[j][i]?.fieldName +
            `</div>`;
          divContent += `<div class="clearBoth"></div>`;
          divContent += `</div>
                        <div class="clearBoth"></div>
                      </div>`;
        } else {
          divContent += `<div class="singleMeasureToPrint_ParentDiv">`;
          if (twoDimantionArray[j][i]?.fieldName != "-") {
            divContent += `<div class="singleMeasureToPrint_ChildLeftDiv">`;
            divContent += ` &nbsp &nbsp &nbsp </div>`;
            divContent += ` <div class="singleMeasureToPrint_ChildRightDiv">`;
            divContent += ` &nbsp &nbsp &nbsp </div> `;
          }
          //divContent += j + ", " + i;=
          divContent += ` </div>`;
        }
      }
      divContent += `<div style="clear:both">`;
    }

    //********************** For extended Note
    divContent += `<hr class="hr_normal" /> <hr class="hr_normal" />`;

    divContent += `<div class="borderOnePic" style="float:left; margin:2px; padding:2px; font-size: 18px;
          font-weight: bolder; color: black;">`;

    props.lstMeasurementDetail
      .filter((item) => item.isNote)
      .forEach((item, index) => {
        if (
          item != null &&
          item?.fieldName !== "undefined" &&
          item?.value !== "undefined" &&
          item?.value !== "" &&
          item?.value !== " " &&
          item?.isNote
        ) {
          // divContent += `<div class="singleMeasureToPrint_ParentDiv borderOnePic">`;
          // divContent += `<div class="borderOnePic" style="float:left; margin:2px; padding:2px; font-size: 14px;
          // font-weight: bolder; color: black;">`;

          if (item?.fieldName != "-") {
            // divContent += `<div class="singleMeasureToPrint_ChildLeftDiv borderOnePic">`;
            divContent += item?.fieldName;
            // divContent += `<div class="clearBoth"></div>`;
            // divContent += `</div>`;
          }
          if (item?.fieldType === 1) {
            divContent += ` (( <b>`;
            divContent += item?.value;
            divContent += `</b>))`;
          }

          divContent += ` || `;

          // divContent += `<div class="clearBoth"></div>
          //             </div>`;
        }
      });
    divContent += `<div class="clearBoth"></div>
      </div>`;

    //*******   Old Code: Show only those has value      */

    // const renderedMatrix3 = [];
    // for (let i = 0; i < rowMax; i++) {
    //   for (let j = 0; j < twoDimantionArray.length; j++) {
    //     if (
    //       twoDimantionArray[j][i] != null &&
    //       twoDimantionArray[j][i]?.fieldName !== "undefined" &&
    //       twoDimantionArray[j][i]?.value !== "undefined" &&
    //       !twoDimantionArray[j][i]?.isNote
    //     ) {
    //       divContent += `<div class="singleMeasureToPrint_ParentDiv borderOnePic">`;

    //       if (
    //         twoDimantionArray[j][i]?.fieldName != "-" ||
    //         twoDimantionArray[j][i]?.fieldName != ""
    //       ) {
    //         divContent += `<div class="singleMeasureToPrint_ChildLeftDiv">`;
    //         divContent += twoDimantionArray[j][i]?.fieldName;
    //         divContent += `<div class="clearBoth"></div>`;
    //         divContent += `</div>`;
    //       }

    //       if (
    //         twoDimantionArray[j][i]?.fieldName === "-" ||
    //         twoDimantionArray[j][i]?.fieldName === ""
    //       ) {
    //         divContent += ` <div class="singleMeasureToPrint_ChildRightDiv width-full-Important">`;
    //       } else {
    //         divContent += ` <div class="singleMeasureToPrint_ChildRightDiv borderLeftOnePic">`;
    //       }

    //       // divContent += ` <div class="singleMeasureToPrint_ChildRightDiv borderOnePic">`;
    //       divContent += twoDimantionArray[j][i]?.value;
    //       divContent += `<div class="clearBoth"></div>`;
    //       divContent += `</div>
    //                     <div class="clearBoth"></div>
    //                   </div>`;
    //     } else {
    //       divContent += `<div class="singleMeasureToPrint_ParentDiv">`;
    //       if (twoDimantionArray[j][i]?.fieldName != "-") {
    //         divContent += `<div class="singleMeasureToPrint_ChildLeftDiv">`;
    //         divContent += ` &nbsp &nbsp &nbsp </div>`;
    //         divContent += ` <div class="singleMeasureToPrint_ChildRightDiv">`;
    //         divContent += ` &nbsp &nbsp &nbsp </div> `;
    //       }
    //       //divContent += j + ", " + i;=
    //       divContent += ` </div>`;
    //     }
    //   }
    //   divContent += `<div style="clear:both">`;
    // }

    // //********************** For extended Note
    // divContent += `<hr class="hr_normal" /> <hr class="hr_normal" />`;

    // props.lstMeasurementDetail
    //   .filter((item) => item.isNote)
    //   .forEach((item, index) => {
    //     if (
    //       item != null &&
    //       item?.fieldName !== "undefined" &&
    //       item?.value !== "undefined" &&
    //       item?.value !== "" &&
    //       item?.value !== " " &&
    //       item?.isNote
    //     ) {
    //       // divContent += `<div class="singleMeasureToPrint_ParentDiv borderOnePic">`;
    //       divContent += `<div class="borderOnePic" style="float:left; margin:5px; padding:5px;">`;

    //       if (item?.fieldName != "-") {
    //         // divContent += `<div class="singleMeasureToPrint_ChildLeftDiv borderOnePic">`;
    //         divContent += item?.fieldName;
    //         // divContent += `<div class="clearBoth"></div>`;
    //         // divContent += `</div>`;
    //       }
    //       if (item?.fieldType === 1) {
    //         divContent += ` (( <b>`;
    //         divContent += item?.value;
    //         divContent += `</b>))`;
    //       }

    //       divContent += `<div class="clearBoth"></div>
    //                   </div>`;
    //     }
    //   });

    setRenderedMatrix(divContent);

    //** Filter */
    console.log(
      "props.orderProductItemStore ==== > " +
        JSON.stringify(props.orderProductItemStore)
    );

    let filteredOrderDetail = props.orderProductItemStore.filter((pi) => {
      return pi.orderDetailID_GUID === props.orderDetailID_GUID_props;
    });

    console.log(
      "filteredOrderDetail ----- > " + JSON.stringify(filteredOrderDetail)
    );
    setOrderDetailToShow(...filteredOrderDetail);

    // setOrderDetailToShow
  }, [props.lstMeasurementDetail]);

  //** Send "Barcode ID to parent component" */
  useEffect(() => {
    //alert("call props" + orderDetailToShow?.orderDetailID);
    props.setBarcodeItemTrackingNo(orderDetailToShow?.orderDetailID);
  }, [orderDetailToShow?.orderDetailID]);

  return (
    <Fragment>
      {/* <hr /> */}
      <div className="media mb-4 mt-1">
        <div className="media-body">
          <div className="ordermeasure-titlee" style={{ width: "93%" }}>
            <div
              style={{
                float: "left",
                width: "63%",
                color: "black",
                fontSize: "18px",
              }}
            >
              <b>{translation.Customer_Name}:</b> {props.customerName}
            </div>
            <div style={{ float: "right" }}>
              <h4 className="m-0 text-primary">
                {props.lstMeasurementDetail[0].name} ( {translation.QTY}:{" "}
                {orderDetailToShow?.qty}) &nbsp;&nbsp;&nbsp; {translation.Tracking_NO}:
                <b> {orderDetailToShow?.orderDetailID} </b>
              </h4>
            </div>
            <div className="clearBoth"></div>
            <div>
              <h4 className="m-0 text-primary">
              {translation.NOTE}:
                <b> {orderDetailToShow?.note} </b>
              </h4>
            </div>
          </div>
          <div className="clearBoth"></div>

          <div style={{ minHeight: "100px", clear: "both" }}>
            <div dangerouslySetInnerHTML={{ __html: renderedMatrix }} />
            {/* <div>Comment: {props.comment}</div> */}
          </div>
        </div>
      </div>
    </Fragment>
  );
};

export default ShowSingleMeasurementPrint;
